
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { InvoiceListService } from 'src/app/core/services/list-services/invoice-list.service';
import { MyfileModel } from 'src/app/core/models/myfile/myfile.model';
import { DomSanitizer } from '@angular/platform-browser';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { InvoiceExtendedModel } from 'src/app/core/models/commerce/invoice-extended.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { InvoiceListConfig } from './invoice-list.config';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { ExportType } from 'src/app/core/models/reporting/export-config-model';
import { TableConfigService } from 'src/app/core/services/table-config.service';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss']
})
export class InvoiceListComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  override listItemsObservable!: Observable<MyfileModel[]>;

  configItemsObservable!: Observable<TableConfigurationModel[]>;
  //Security Operations of the current User
  securityPermissionInvoiceUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreateInvoice);

  protected override searchPlaceHolderText: string = "Search for client number, name, or email";

  constructor(
    protected taskModalService: TaskModalService,
    public invoiceListService: InvoiceListService,
    protected tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
    protected override toasterNotificationService: ToasterNotificationService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    this.tableConfig = new InvoiceListConfig();
    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));
        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.invoiceListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.invoiceListService.invoices$;
    this.total = this.invoiceListService.total$;
    this.isLoading = this.invoiceListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((extendedInvoiceModel: InvoiceExtendedModel) => {
        this.getEntityPhoto(extendedInvoiceModel.account, EntityTypeEnum.Account);
        this.getEntityPhoto(extendedInvoiceModel.client, EntityTypeEnum.Client);
        this.getEntityPhoto(extendedInvoiceModel.requisition, EntityTypeEnum.Requisition);
        this.getEntityPhoto(extendedInvoiceModel.user, EntityTypeEnum.User);
        extendedInvoiceModel = this.addEntityType(extendedInvoiceModel, EntityTypeEnum.Invoice);
        extendedInvoiceModel.account = this.addEntityType(extendedInvoiceModel.account, EntityTypeEnum.Account);
        extendedInvoiceModel.client = this.addEntityType(extendedInvoiceModel.client, EntityTypeEnum.Client);
        extendedInvoiceModel.requisition = this.addEntityType(extendedInvoiceModel.requisition, EntityTypeEnum.Requisition);
        extendedInvoiceModel.user = this.addEntityType(extendedInvoiceModel.user, EntityTypeEnum.User);
      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.invoiceListService.totalRecords;
      this.serviceData.pageSize = this.invoiceListService.pageSize;
      this.serviceData.pageIndex = this.invoiceListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);
  }

  addEntityType(model: any, entityType: EntityTypeEnum): any {
    if (model.entityType === undefined) {
      model.entityType = entityType;
    }
    return model;
  }

  openModel(entityType: EntityTypeEnum, model: any) {
    switch (entityType) {
      case EntityTypeEnum.Client:
        this.openModalService.editClientModal(this.invoiceListService, model.id);
        break;

      case EntityTypeEnum.Account:
        this.openModalService.editContactModal(this.invoiceListService, model.id);
        break;

      case EntityTypeEnum.Requisition:
        this.openModalService.editRequisitionModal(this.invoiceListService, model.id);
        break;

      case EntityTypeEnum.User:
        if (this.authMyFileService.canAccessOperation(SecurityOperations.user.userReadAll)) {
          this.openModalService.editUserModal(model.id, undefined, this.invoiceListService);
        }
        break;

      case EntityTypeEnum.Invoice:
        this.viewMyfile(model.requisitionId, model.myFileId);
        break;
    }
  }

  ngOnDestroy() {
    this.listItems = undefined;
    this.clearSearch(this.invoiceListService);
    this.clearSearch(this.tableConfigService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  //** new simpler sort function for further lists with new layout component */
  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.invoiceListService, '', '');
    } else {
      this.serviceSort(this.invoiceListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  buttonActionSelected(buttonAction: any) {
    switch (buttonAction) {
      case `${ButtonIdEnum.ExportCSV}`:
        this.exportTo(ExportType.Csv, this.invoiceListService.searchModel, "Myfile Invoice List", "Invoices",this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportExcel}`:
        this.exportTo(ExportType.Excel, this.invoiceListService.searchModel, "Myfile Invoice List", "Invoices",this.tableConfig)
        break;
    }
  }

  rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.View:
        this.viewMyfile(rowAction.model.requisitionId, rowAction.model.myFileId);
        break;
      case ActionIdEnum.Edit:
        this.openModel(rowAction.model.entityType, rowAction.model)
        break;
      case ActionIdEnum.Download:
        this.downloadMyfile(rowAction.model.requisitionId, rowAction.model.myFileId);
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel): void {
    switch (filterSelected.label) {
      case "status":
        this.invoiceListService.status = filterSelected.selectedOption as any;
        break;
    }
  }


  viewMyfile(requisitionId: string, myfileId: string) {
    this.isLoadingVal = true;
    if (requisitionId && myfileId) {
      this.myFileApiService.viewMyFile(requisitionId, myfileId).subscribe((result: any) => {
        if (result) {
          this.pdfModalService.openModal(result, result.name);
        }
        this.isLoadingVal = false;
        var sub: Subscription = this.pdfModalService.modelChanged.subscribe(() => {
          sub.unsubscribe();
        })
      });
    } else {
      this.isLoadingVal = false;
    }
  }

  downloadMyfile(requisitionId: string, myfileId: string,) {
    this.isLoadingVal = true;
    if (requisitionId && myfileId) {
      this.myFileApiService.downloadMyFile(requisitionId, myfileId).subscribe((result: any) => {
        this.isLoadingVal = false
      });
    }
  }
}